module.exports = __webpack_public_path__ + "static/media/1996_GDP_totalRate.63dc1df2.png";